module.exports = __webpack_public_path__ + "img/cdn.43c08023.svg";